export class Storage<StorageObject extends { [key: string]: any }> {
  constructor(private key: string) {}

  get<TKey extends keyof StorageObject>(
    name: TKey
  ): StorageObject[TKey] | undefined {
    return this.read()[name];
  }

  set<TKey extends keyof StorageObject>(
    name: TKey,
    value: StorageObject[TKey]
  ) {
    const obj = this.read();
    obj[name] = value;
    this.write(obj);
  }

  private read(): Partial<StorageObject> {
    try {
      const value = localStorage.getItem(this.key);
      return value ? JSON.parse(value) : {};
    } catch (e) {
      return {};
    }
  }

  private write(obj: Partial<StorageObject>) {
    localStorage.setItem(this.key, JSON.stringify(obj));
  }
}
